import React from "react";
import { 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  Checkbox, 
  ListItemText, 
  OutlinedInput,
  Box,
  Chip
} from "@mui/material";

interface StaffSelectProps {
  value: string[];
  staffMembers: { _id: { $oid: string }; staff_name: string }[];
  onChange: (value: string[]) => void;
}

const StaffSelect: React.FC<StaffSelectProps> = ({ value, staffMembers, onChange }) => {
  // Function to get staff names from selected IDs
  const getSelectedStaffNames = () => {
    return staffMembers
      .filter(staff => value.includes(staff._id.$oid))
      .map(staff => staff.staff_name);
  };

  const handleChange = (event: any) => {
    const selectedValue = event.target.value;
    const newValue = typeof selectedValue === 'string' ? selectedValue.split(',') : selectedValue;
    onChange(newValue);
  };

  return (
    <FormControl fullWidth variant="outlined" sx={{ mt: 0 }}>
      <InputLabel id="staff-select-label">Assign Staff Members</InputLabel>
      <Select
        labelId="staff-select-label"
        id="staffList"
        multiple
        value={value}
        onChange={handleChange}
        input={<OutlinedInput label="Assign Staff Members" />}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {getSelectedStaffNames().map((staffName) => (
              <Chip key={staffName} label={staffName} size="small" />
            ))}
          </Box>
        )}
        MenuProps={{
          PaperProps: {
            sx: {
              mt: 1,
              maxHeight: 48 * 6,
            },
          },
        }}
      >
        {staffMembers.map((staff) => (
          <MenuItem key={staff._id.$oid} value={staff._id.$oid}>
            <Checkbox checked={value.indexOf(staff._id.$oid) > -1} />
            <ListItemText primary={staff.staff_name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default StaffSelect;